// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import Cookies from 'js-cookie';
import * as echarts from 'echarts';
import '@/style/element-variables.scss';
import '@/style/index.scss';
import '@/style/color.scss';
import '@/style/scrollbar.scss';
import '@/utils/iconfont.js';
import './permission';
import * as validator from '@/utils/validator';
import App from './App'
import IIcon from '@/components/common/IIcon';
import TableCustom from '@/components/common/TableCustom';
import SlideVerify from 'vue-monoplasty-slide-verify';
import '@/utils/directives';
import VueBus from './utils/vue-bus';
import {
  generateDeletedItems,
  filterChainItems,
  transColor,
  transColor2,
  transColor3
} from '@/utils/common';

Vue.config.productionTip = false
Vue.use(ElementUI, { size: Cookies.get('size') || 'medium', zIndex: 3000 })
Vue.use(SlideVerify)
Vue.use(VueBus);
Vue.component('IIcon', IIcon)
Vue.component('TableCustom', TableCustom)
Vue.prototype.$validator = validator;
Vue.prototype.$echarts = echarts;
Vue.prototype.$generateDeletedItems = generateDeletedItems;
Vue.prototype.$filterChainItems = filterChainItems;
Vue.prototype.$transColor = transColor;
Vue.prototype.$transColor2 = transColor2;
Vue.prototype.$transColor3 = transColor3;

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default vue;


// WEBPACK FOOTER //
// ./src/main.js